// extracted by mini-css-extract-plugin
export default {"header":"TableList_header__ONY94","row":"TableList_row__bsU3N"};